/*------------------------------------------------------------------------------------------
* © 2020 KPMG LLP, a Delaware limited liability partnership and 
* a member firm of the KPMG global organization of independent member firms 
* affiliated with KPMG International Limited, a private English company limited by guarantee. 
* All rights reserved.
*-----------------------------------------------------------------------------------------*/
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthPolicyService } from '../services/auth-policy.service';
import { Urls } from 'src/app/models/application-enum.model';
import { switchMap, catchError, map } from 'rxjs/operators';
import { UserWithRole } from 'src/app/models/user.model';

@Injectable({
  providedIn: 'root'
})
export class AdminGuardGuard  {
  constructor(private _authService: AuthPolicyService, private _router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      return this._authService.getUserRoles().pipe(
        switchMap((currentUserRole: any) => {
          if (currentUserRole && currentUserRole.roleName=='Admin') {
            return this._authService.isAdmin().pipe(
              map(response => {
                if (response) {
                  return true;
                } else {
                  this._router.navigateByUrl(Urls.accessDenied);
                  return false;
                }
              }),
              catchError((error, caught) => {
                this._router.navigateByUrl(Urls.accessDenied);
                return of(false);
              })
            );
          } else {
            this._router.navigateByUrl(Urls.accessDenied);
            return of(false);
          }
        }),
        catchError((error, caught) => {
          this._router.navigateByUrl(Urls.accessDenied); 
          return of(false);
        })
      );
    // this._authService.getUserRoles().subscribe(response => {
    //   let x = response;
    // }, error => {

    // })
    // this._router.navigateByUrl(Urls.accessDenied);
    // return false;
  }

}
